<template>
  <div class="box-card">
    <div class="section text-aligh-center">
      <el-image style="width: 100px;" :src="require('@/assets/logo.png')" :fit="fit" />
      <h1>魔期AI平台（股票版Beta）</h1>
      <h5 class="pt-8">专注国内金融市场的人工智能平台</h5>
    </div>
    <el-card>
      <template #header>
        <div class="card-header">
          <span v-if="obj.type">密码登录</span>
          <span v-else>验证码登录</span>
        </div>
      </template>
      <el-form label-width="60px">
        <el-form-item v-if="obj.type" label="工 号">
          <el-input v-model="obj.mobileNumber" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
            style="width:290px" maxlength="11" placeholder="工号" @keyup.enter="handleEnter" />
        </el-form-item>
        <el-form-item v-else label="手机号">
          <el-input v-model="obj.mobileNumber" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
            style="width:290px" maxlength="11" placeholder="手机号" @keyup.enter="handleEnter" />
        </el-form-item>
        <el-form-item v-if="obj.type" label="密 码">
          <el-input v-model="obj.password" type="password" style="width:290px" maxlength="20" placeholder="密码"
            @keyup.enter="handleEnter" />
        </el-form-item>
        <el-form-item v-else label="验证码">
          <el-input v-model="obj.vcode" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
            style="width:210px;padding-right:10px" maxlength="6" placeholder="验证码" @keyup.enter="handleEnter" />
          <el-button type="primary" @click="getCode" style="width:80px">获取验证码</el-button>
        </el-form-item>
        <div class="pt-16">
          <el-button v-if="obj.type" type="primary" @click="submit" size="large" style="width:100%">登录</el-button>
          <el-button v-else type="primary" @click="submit" size="large" style="width:100%">登录/注册</el-button>
        </div>
      </el-form>
      <!-- <el-link v-if="obj.type" type="primary" @click="handleChange">短信验证码登录（自动注册并登录）</el-link> -->
      <!-- <el-link v-else type="primary" @click="handleChange">返回密码登录</el-link> -->
      <div v-if="!obj.type" class="pt-32 color-secondary-text font-size-12">未注册过的手机，通过验证后将自动注册并登录</div>
      <div class="pt-16">
        <el-row justify="space-between">
          <el-link href="https://www.morepoll.com" type="primary">返回主页</el-link>
          <el-button type="default" @click="handleWxMiniClick" round>微信小程序</el-button>
        </el-row>
      </div>
    </el-card>
    <wx-mini-dialog></wx-mini-dialog>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { http } from '../util/http'
import { ElMessage } from 'element-plus'
import { LStorage } from "../util/storage"
import WxMiniDialog from "../components/WxMiniDialog.vue"

export default {
  components: { WxMiniDialog },
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const router = useRouter()
    const obj = reactive({
      mobileNumber: '',
      password: '',
      vcode: '',
      type: false // true是密码登录，false是验证码登录
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 渲染画面
    const renderView = () => {
      requestData()
    }

    // 后台获取数据
    const requestData = () => {
      http({
        url: `/check_auth`,
        method: 'post',
      }).then((res) => {
        processData(res)
      })
    }

    // 加工处理数据
    const processData = (res) => {
    }

    /**
     * 事件处理区域
     */

    // 切换登录模式
    const handleChange = () => {
      obj.type = !obj.type
    }

    // 获取验证码
    const getCode = () => {
      if (!formCheckPincode()) {
        return
      }
      let formData = new FormData()
      formData.append("phone_number", obj.mobileNumber)
      formData.append("scene", "1")
      http({
        url: `/sms`,
        method: 'post',
        data: formData
      }).then((res) => {
        console.log(res)
        if (res.data.errmsg != "") {
          ElMessage({ showClose: true, message: res.data.errmsg, duration: 2000 })
        } else {
          ElMessage({ showClose: true, message: "发送成功", duration: 2000 })
        }
        ElMessage({ showClose: true, message: '验证码请输入: 123456', duration: 3000 })
      })
    }

    // 提交后台
    const submit = () => {
      if (!formCheck()) {
        return
      }
      let url = ""
      let formData = new FormData()
      if (obj.type) {
        formData.append("uid", obj.mobileNumber)
        formData.append("password", obj.password)
        url = `/login_pwd`
      } else {
        formData.append("phone_number", obj.mobileNumber)
        formData.append("pincode", obj.vcode)
        url = `/login_pincode`
      }
      http({
        url: url,
        method: 'post',
        data: formData,
      }).then((res) => {
        ElMessage.success("登录成功")
        LStorage.setItem('auth_stock', res.data.auth)
        LStorage.setItem('user', obj.mobileNumber)
        console.log("user", obj.mobileNumber)
        router.push('/')
      })
    }

    // 表单check
    const formCheck = () => {
      if (obj.mobileNumber.trim() === '') {
        if (obj.type) {
          ElMessage.error('请输入工号')
        } else {
          ElMessage.error('请输入手机号')
        }
        return false
      }
      if (obj.mobileNumber.length !== 11) {
        if (obj.type) {
          ElMessage.error('请输入11位工号')
        } else {
          ElMessage.error('请输入11位手机号')
        }
        return false
      }
      if (obj.type && obj.password.trim() === '') {
        ElMessage.error('请输入密码')
        return false
      }
      if (!obj.type && obj.vcode.trim() === '') {
        ElMessage.error('请输入验证码')
        return false
      }
      if (!obj.type && obj.vcode.length !== 6) {
        ElMessage.error('请输入6位验证码')
        return false
      }
      return true
    }

    // 表单check
    const formCheckPincode = () => {
      if (obj.mobileNumber.trim() === '') {
        ElMessage.error('请输入手机号')
        return false
      }
      if (obj.mobileNumber.length !== 11) {
        ElMessage.error('请输入11位手机号')
        return false
      }
      return true
    }

    // 输入框Enter事件
    const handleEnter = () => {
      submit()
    }

    // 微信小程序事件
    const handleWxMiniClick = () => {
      vueEvent.emit("wxMiniDialogVisible", true)
    }

    return {
      obj,
      store,
      handleChange,
      getCode,
      submit,
      handleEnter,
      handleWxMiniClick
    }
  }
}
</script>
<style lang="scss" scoped>
.box-card {
  margin: 50px auto;
  width: 400px;
}
</style>
